export default __webpack_public_path__ + "static/media/restaurant.7ece7ff5.jpg";